export default __webpack_public_path__ + "static/media/Riposa.d8cef92b.jpg";